import application from 'application/application';

// import moment from 'moment';
application.service('blocked', [
	'$http',
	'helper',
	'API',
	function($http, helper, API) {
		const blockedStatus = [-3, -6];

		this.situacoesPermitidas = plano => {
			return Boolean(
				plano.idSituacaoClienteXPlano === -1 ||
					plano.idSituacaoClienteXPlano === -11 ||
					plano.idSituacaoClienteXPlano === -12 ||
					plano.idSituacaoClienteXPlano === -13 ||
					plano.idSituacaoClienteXPlano === -14 ||
					plano.idSituacaoClienteXPlano === -15 ||
					plano.idSituacaoClienteXPlano === -16 ||
					plano.idSituacaoClienteXPlano === -17 ||
					plano.idSituacaoClienteXPlano === -18
			);
		};

		this.updateStatus = async () => {
			const mainStorage =
				JSON.parse(localStorage.getItem('_MAIN_STORAGE_')) || {};

			const contractsClients = mainStorage.contracts || [];

			if (!contractsClients)
				await $http({
					...helper.http(API.clients, 'GET'),
					params: {
						...helper.httpFields(['*']),
						registrosPorPagina: -1,
						contratosAderidos: true
					}
				}).then(response => {
					const mainStorage =
						JSON.parse(localStorage.getItem('_MAIN_STORAGE_')) || {};

					mainStorage.contracts = response.data.itens;

					localStorage.setItem('_MAIN_STORAGE_', JSON.stringify(mainStorage));

					contractsClients = response.data.itens;
				});

			let contract = contractsClients;

			const activated = contract[0].contratosCliente.some(
				register => register.idSituacaoContrato === -1
			);

			const hasActiveWithoutOab = contract[0].contratosCliente.some(
				register => register.idSituacaoContrato === -1
			);

			if (!activated && !hasActiveWithoutOab) {
				let canOpen = true;

				let blocked = false;

				contract[0].contratosAderidos.forEach(plano => {
					if (this.situacoesPermitidas(plano)) canOpen = true;
				});

				if (!canOpen) {
					contract[0].contratosAderidos.forEach(element => {
						if (
							(element.idSituacaoContrato === -1 ||
								element.idSituacaoContrato === -11) &&
							!element.convenioOAB
						) {
							canOpen = true;
							blocked = false;
						} else {
							blockedStatus.forEach(blocked => {
								if (element.idSituacaoContrato == blocked) {
									canOpen = false;
								}
							});

							blocked = true;
						}
					});

					localStorage.setItem('__authenticationUserBlocked__', blocked);
				}
			} else {
				const filteredContracts = contract[0].contratosCliente.filter(
					contract =>
						contract.idSituacaoContrato === -1 ||
						contract.idSituacaoContrato === -11
				);

				if (filteredContracts.length)
					localStorage.setItem('__authenticationUserBlocked__', false);
				else {
					contract[0].contratosCliente.forEach(element => {
						blockedStatus.forEach(blocked => {
							if (element.idSituacaoContrato == blocked) {
								localStorage.setItem('__authenticationUserBlocked__', true);
							}
						});
					});
				}
			}
		};
	}
]);
